import {unlockAudioEngine} from 'utils/audioEngine';

let primed = false;

// Call from inside a real, early user gesture (e.g. the language-select tap
// at the very start of a session) to unlock the shared Web Audio context for
// the rest of the page's life. See audioEngine.js for why this — unlike
// priming a plain <audio> element — actually carries over to later,
// gesture-less autoplay attempts on iOS Safari.
export default function primeAudioPlayback() {
	if (primed) {
		return;
	}

	primed = true;
	unlockAudioEngine();
}
